var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "samc-modal",
    { attrs: { width: "650px" } },
    [
      _c("samc-modal-header", [_vm._v("\n    Deal/Sales Import\n  ")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pb-6 h-24" },
        [
          _c(
            "samc-file-input",
            {
              attrs: { accept: ".xls,.xlsx", "enable-full-size": "" },
              on: { valuechanged: _setup.fileChanged },
            },
            [
              _setup.file === null
                ? _c("span", { attrs: { slot: "text" }, slot: "text" }, [
                    _vm._v("Drag and drop a template file to import file"),
                  ])
                : _c("span", { attrs: { slot: "text" }, slot: "text" }, [
                    _vm._v(_vm._s(_setup.file.name) + ", is ready for import"),
                  ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _setup.errors.length > 0
        ? _c(
            "div",
            { staticClass: "h-32 mb-6 legacy-error-grid" },
            [
              _c(
                "samc-grid",
                { ref: "grid" },
                [
                  _c("samc-grid-column", {
                    attrs: {
                      field: "errorDesc",
                      "header-name": "Error Message",
                      flex: 1,
                    },
                  }),
                  _vm._v(" "),
                  _c("samc-grid-column", {
                    attrs: { field: "colName", "header-name": "Column Name" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-row items-center gap-2" },
        [
          _c(
            "samc-action",
            {
              on: {
                click: function ($event) {
                  return _setup.downloadTemplate()
                },
              },
            },
            [_c("icon-download"), _vm._v(" Download Template\n    ")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex-grow" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid grid-cols-2 gap-2" },
            [
              _c(
                "samc-button",
                {
                  attrs: { type: "secondary" },
                  on: {
                    click: function ($event) {
                      return _setup.close()
                    },
                  },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
              _vm._v(" "),
              _c(
                "samc-button",
                {
                  attrs: { disabled: _setup.file === null },
                  on: {
                    click: function ($event) {
                      return _setup.uploadFile()
                    },
                  },
                },
                [_vm._v("\n        Process Template\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }